const imageHeight = 50;

/**
 * @TODO the default and special ist just a test, we need to know what label types and add the images for them
 */
const imageMap = {
  default: "fng",
  special: "fng",
  transition: "fng",
};

export default ({ labelType }) => [
  {
    margin: [37, 0, 37, 0],
    columns: [
      {
        width: "auto",
        stack: [
          {
            image: "air",
            width: (imageHeight / 145) * 616,
          },
        ],
      },
      {
        text: null,
        width: "*",
      },
      {
        width: "auto",
        stack: [
          {
            image: imageMap[labelType] || "fng",
            width: ((imageHeight + 5) / 166) * 166,
          },
        ],
      },
    ],
  },
];
